/**
 * Збережені вакансії (owner 2026-09-06).
 *
 * Owner 2026-09-08: «зробив би її як копію стрічки вакансій — виглядає так
 * само, функціонал такий самий, так само розкриваються. Новий дизайн не
 * робити». Тому сторінка НЕ малює власних карток: вона рендерить той самий
 * `FeedCard`, що й стрічка, з тією ж логікою розгортання.
 *
 * Єдина свідома відмінність — БЕЗ позначки «переглянуто» (owner 2026-09-08:
 * «функція переглянута в збережених недоречна»). У стрічці вона відділяє нове
 * від баченого; збережене людина відклала сама, гасити його немає сенсу.
 */
import { useState } from "react";
import { BackNav } from "@/components/BackNav";
import { PageHeader } from "@/components/PageHeader";
import { PageLoadError } from "@/components/LockedPage";
import { Spinner } from "@/components/Spinner";
import { FeedCard } from "@/pages/Feed";
import { useSavedVacancies } from "@/api/hooks";
import type { FeedItemOut } from "@/api/hooks";
import { tg } from "@/lib/telegram";

export function SavedPage() {
  const q = useSavedVacancies();
  const [expandedId, setExpandedId] = useState<number | null>(null);

  if (q.isLoading) return <Spinner />;
  if (q.isError) return <PageLoadError error={q.error} section="saved" fallback="Не вдалося завантажити збережені вакансії." />;

  const items: FeedItemOut[] = q.data?.items ?? [];

  return (
    <>
      <BackNav showMenu />

      <PageHeader
        eyebrow="вакансії"
        title="Збережені вакансії"
        titleLead="Збережені"
        titleAccent="вакансії."
        scribbleWidth={165}
        subtitle="Те, що ти відклав, щоб повернутись і написати замовнику, коли буде час."
      />

      {items.length === 0 ? (
        <div className="pt-2 text-[0.8125rem] text-ink-dim [text-wrap:balance]">
          Поки порожньо. Натисни «Зберегти» під вакансією — у боті або в її
          картці, — і вона зʼявиться тут.
        </div>
      ) : (
        <div className="space-y-3 pt-1">
          {items.map((item) => (
            <FeedCard
              key={item.id}
              item={item}
              isNew={false}
              // Owner 2026-09-08: позначка «переглянуто» тут недоречна.
              // У стрічці вона відділяє нове від уже баченого, а збережене
              // людина відклала свідомо — гасити його немає сенсу.
              viewed={false}
              expanded={expandedId === item.id}
              onToggle={() => {
                tg()?.HapticFeedback?.selectionChanged?.();
                setExpandedId((cur) => (cur === item.id ? null : item.id));
              }}
            />
          ))}
        </div>
      )}
    </>
  );
}
